import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import {
  GET_ALL_INTERVIEWERS,
  GET_ALL_INTERVIEWERS_SUCCESS,
  ADD_INTERVIEWER,
  DELETE_INTERVIEWER,
} from '../../constants/ActionTypes';
import {
  IAddInterviewerActionPayload,
  IDeleteInterviewerActionPayload,
  IFeedbackRevisionActionPayload,
} from '../../types/Interviews/interviewers.types';
import {
  getInterviewersApi,
  addInterviewerApi,
  deleteInterviewerApi,
} from '../../api/Interviews/interviewers.api';
import { DO_CENTRAL_SERVICE_URL } from '../../constants/AppConstants';
import { showAlert } from '../../actions/alert.action';
import { HTTP_STATUS_CODES } from '../../constants/HttpConstants';
import { apiErrorHandler } from '../../utils/api-helpers';
import {
  INTERVIEWERS_API_HTTP_STATUS_CODES,
  INTERVIEWERS_ERROR_MESSAGE,
  INTERVIEWER_ADDING_API_HTTP_STATUS_CODES,
  INTERVIEWER_ADDING_ERROR_MESSAGE,
  INTERVIEWER_DELETE_API_HTTP_STATUS_CODES,
  INTERVIEWER_DELETE_ERROR_MESSAGE,
} from '../../constants/Interviews/InterviewerConstants';

function* getInterviewersSaga() {
  try {
    const getInterviewersResp: AxiosResponse = yield call(getInterviewersApi);
    if (
      getInterviewersResp &&
      getInterviewersResp.status === HTTP_STATUS_CODES.OK &&
      getInterviewersResp?.data
    ) {
      yield put({
        type: GET_ALL_INTERVIEWERS_SUCCESS,
        payload: getInterviewersResp.data,
      });
    } else {
      const redirectUrl = `${DO_CENTRAL_SERVICE_URL}/login?next=${window.location.href}`;
      window.location.replace(redirectUrl);
    }
  } catch (error) {
    const message: string | null = yield call(
      apiErrorHandler,
      error,
      INTERVIEWERS_API_HTTP_STATUS_CODES,
      INTERVIEWERS_ERROR_MESSAGE
    );
    if (message)
      yield put(
        showAlert({
          show: true,
          message,
          type: 'error',
        })
      );
  }
}

function* addInterviewerSaga({ payload }: IAddInterviewerActionPayload) {
  try {
    const addInterviewerResp: AxiosResponse = yield call(
      addInterviewerApi,
      payload
    );
    if (
      addInterviewerResp &&
      (addInterviewerResp.status === HTTP_STATUS_CODES.CREATED ||
        addInterviewerResp.status === HTTP_STATUS_CODES.OK)
    ) {
      const { message } = addInterviewerResp.data;
      yield put(
        showAlert({
          show: true,
          message,
          type: 'success',
        })
      );
      yield put({
        type: GET_ALL_INTERVIEWERS,
      });
    }
  } catch (error) {
    const message: string | null = yield call(
      apiErrorHandler,
      error,
      INTERVIEWER_ADDING_API_HTTP_STATUS_CODES,
      INTERVIEWER_ADDING_ERROR_MESSAGE
    );
    if (message)
      yield put(
        showAlert({
          show: true,
          message,
          type: 'error',
        })
      );
  }
}

function* deleteInterviewerSaga({ payload }: IDeleteInterviewerActionPayload) {
  try {
    const deleteInterviewerResp: AxiosResponse = yield call(
      deleteInterviewerApi,
      payload
    );
    const { message } = deleteInterviewerResp.data;
    if (
      deleteInterviewerResp &&
      deleteInterviewerResp.status === HTTP_STATUS_CODES.OK
    ) {
      yield put(
        showAlert({
          show: true,
          message,
          type: 'success',
        })
      );
      yield put({
        type: GET_ALL_INTERVIEWERS,
      });
    }
  } catch (error) {
    const message: string | null = yield call(
      apiErrorHandler,
      error,
      INTERVIEWER_DELETE_API_HTTP_STATUS_CODES,
      INTERVIEWER_DELETE_ERROR_MESSAGE
    );
    if (message)
      yield put(
        showAlert({
          show: true,
          message,
          type: 'error',
        })
      );
  }
}

export default function* loadInterviewersSaga() {
  yield takeLatest(GET_ALL_INTERVIEWERS, getInterviewersSaga);
  yield takeLatest(ADD_INTERVIEWER, addInterviewerSaga);
  yield takeLatest(DELETE_INTERVIEWER, deleteInterviewerSaga);
}
